<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="7"/>
    <div class="zmpp_con w1200" style="text-align:center;">
      <div class="demo-image__preview" style="margin-top:60px;width:100%;display: inline-block;">
        <ul class="clearfix demo-image__preview">
          <li class="demo-image__preview" v-for="(item,index) in honorList" :key="index">
            <el-image
              :src="item.imgpath"
              :preview-src-list="imgList"
              :large="item.imgpath"
              fit="cover"
              preview="0"
              @click="handleClickItem"
              >
              <div slot="error" class="image-slot">
                <img src="../../assets/images/zwtp.jpg"/>
              </div>
            </el-image>
            <h3>{{item.title}}</h3>
          </li>
        </ul>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import api from '@/api/honor'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'

export default {
  name: 'Honor',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      honorList: [],
      honorCount: '',
      imgList: []
    }
  },
  mounted () {
    this.gethonor()
  },
  methods: {
    gethonor () {
      api.gethonor().then(res => {
        this.honorList = res.items
        console.info(this.honorList[0]['imgpath'])
        this.imgList = res.imgList
      })
    },
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    }
  }
}
</script>
<style scoped>
.clearfix li {
  width: 24%;
  margin: 12px 5px;
  float: left;
}
.clearfix li img {
  width: 100%;
  border: 1px solid #efefef;
  height: 370px;
}
.clearfix h3{
  margin: 10px;
  height: 20px;
}
.el-image {
  height:370px;
  position: relative;
  display: inline-block;
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/view/honor/honor.vue